import { z } from 'zod';

import { ExportSingleQuestionFormat, QuestionExportFileTemplate } from '../../constants';

export const QuestionExportFormSchema = z.object({
  fileType: z.nativeEnum(ExportSingleQuestionFormat),
  template: z.nativeEnum(QuestionExportFileTemplate),
});

export type QuestionExportFormInput = z.infer<typeof QuestionExportFormSchema>;
